// This function is used in the select component to get the new value after an option is selected (for keyboard focus usage).
export function scrollIntoView(element, options) {
  var {
    block = 'start'
  } = options;
  var parent = element.parentElement;
  if (!parent) return;
  var parentRect = parent.getBoundingClientRect();
  var elementRect = element.getBoundingClientRect();
  if (block === 'nearest') {
    if (elementRect.top < parentRect.top) {
      parent.scrollTop -= parentRect.top - elementRect.top;
    } else if (elementRect.bottom > parentRect.bottom) {
      parent.scrollTop += elementRect.bottom - parentRect.bottom;
    }
  } else {
    parent.scrollTop = element.offsetTop - parentRect.top;
  }
}

// This function is used in the select component to check if the value has a value.
export function selectHasValue(value) {
  return value && Array.isArray(value) && value.length > 0 && value[0] !== undefined;
}

// This function is used in the select component to check if the character is printable.
export function isPrintableCharacter(str) {
  return str.length === 1 && !!str.match(/\S/);
}

// This function is used in the select component to focus the search input.
export function focusSearchInput(searchInputRef) {
  var _searchInputRef$curre;
  (_searchInputRef$curre = searchInputRef.current) === null || _searchInputRef$curre === void 0 || _searchInputRef$curre.focus();
}